import React, { useEffect } from 'react';
import { api } from './App';

const RELEASES = [
  {
    version: 'v1.1',
    date: '6 April 2026',
    iso: '2026-04-06',
    items: [
      {
        title: 'SRA Questions — performance now shown in topic view',
        detail: 'Your SRA accuracy for each subject area now appears alongside confidence scores in FLK1 and FLK2. The dashboard priority list also shows your SRA accuracy badge when relevant.',
      },
      {
        title: 'Practice mode — full question-by-question review',
        detail: 'After completing a practice session in SRA Questions, you can now review every question with your answer vs. the correct answer — the same detailed breakdown as exam mode.',
      },
      {
        title: 'Law Drills support added',
        detail: 'You can now import MCQ results from Law Drills as well as BARBRI. Select your provider in the MCQ Results tab.',
      },
      {
        title: 'Active Recall — lighter confidence adjustment',
        detail: 'Self-assessment scores from recall sessions now blend more gently with your existing confidence (85/15 weighting), so a single session won\'t swing your score dramatically.',
      },
      {
        title: 'Onboarding — redesigned import step',
        detail: 'The starting flow now shows three clear full-page options: download our template, import your own spreadsheet, or start fresh. No more dark overlay — clean white background throughout.',
      },
      {
        title: 'Planner — session saving fixed',
        detail: 'Fixed a bug where planner sessions could disappear after navigating away. Sessions now save reliably the first time.',
      },
      {
        title: 'Progress chart — FLK1/FLK2 filter',
        detail: 'You can now view FLK1 and FLK2 confidence trends separately using the toggle above the chart.',
      },
    ],
  },
  {
    version: 'v1.0',
    date: '2 April 2026',
    iso: '2026-04-02',
    items: [
      {
        title: 'SQETrack is live',
        detail: 'Track your confidence across 259 FLK1 and FLK2 topics, import BARBRI practice results, practise with 220 official SRA questions, plan your revision week by week, and track your progress toward exam day.',
      },
    ],
  },
];

export default function Changelog({ onViewed }) {
  useEffect(() => {
    // Mark changelog as viewed
    api('/api/settings', {
      method: 'POST',
      body: JSON.stringify({ changelog_last_viewed: new Date().toISOString().slice(0, 10) }),
    });
    if (onViewed) onViewed();
  }, []); // eslint-disable-line

  return (
    <div className="changelog-page">
      <div className="changelog-header">
        <div className="changelog-title">What's new</div>
        <div className="changelog-subtitle">SQETrack release notes.</div>
      </div>
      <div className="changelog-list">
        {RELEASES.map((release, ri) => (
          <div key={release.version} className={`changelog-release ${ri === 0 ? 'changelog-release--open' : ''}`}>
            <div className="changelog-release-header-static">
              <div className="changelog-release-left">
                <span className="changelog-version">{release.version}</span>
                <span className="changelog-date">{release.date}</span>
              </div>
            </div>
            <div className="changelog-items">
              {release.items.map((item, i) => (
                <div key={i} className="changelog-item">
                  <div className="changelog-item-title">{item.title}</div>
                  <div className="changelog-item-detail">{item.detail}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// Export for use in App.js to determine whether to show "New" badge
export const LATEST_CHANGELOG_DATE = RELEASES[0].iso;
